import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import CargasEmLoteResponse from '@/model/response/CargasEmLoteResponse'

export default class UploadDados extends Resource {

  static async getLastUpload(idScreenUpload: number, spinner = 'getLastUpload') {
    const fetch = async () => await new HttpBody<UploadDados>().GET(`/user/import-file/ultimo/${idScreenUpload}`)
    return await $.await.run(fetch, spinner)
  }

  readonly $endpoint: string = '/user/import-file'

  get $id() {
    return this.idUploadDadosPk
  }
  set $id(val: ID) {
    this.idUploadDadosPk = val
  }

  idUploadDadosPk: ID = 0
  urlArquivo: string | null = null
  idTipoUploadFk: ID = 0
  mensagemErro: string | null = null
  idStatusUploadFk: number = 0

  respInt: number | null = null
  respListLong: number[] | null = null

  respCargasEmLote: CargasEmLoteResponse | null = null

  async inserirNaFila(spinner = 'inserirNaFila') {
    const fetch = async () => {
      return await new HttpBody().POST(`/user/import-file`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getUploadDados(id: number | string, spinner = 'getUploadDados') {
    const fetch = async () => await this.GET(`/user/import-file/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
